import React, { useState, useEffect } from "react";
import { Select, DatePicker, Input, Button, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Filterloader from "../../../../../components/loaderFilter";
import * as zoneActions from "../../../../../redux/actions/zone.actions";
import * as actionPage from "../../../../../redux/actions/orderManagementListing.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
const { RangePicker } = DatePicker;

const statusOption = [
  {label: 'Un Assigned',value: 'un-assigned'},
  {label: 'Accepted',value: 'accepted'},
  {label: 'Pickup Reached',value: 'pickup_reached'},
  {label: 'Pickup Successful',value: 'pickup_successful'},
  {label: 'Dropoff Started',value: 'dropoff_started'},
  {label: 'Dropoff Reached',value: 'dropoff_reached'},
  {label: 'Dropoff Successful',value: 'dropoff_successful'},
  // {label: 'Cancel',value: 'cancel'},
  // {label: 'Pending',value: 'pending'},
  // {label: 'On Route',value: 'on_route'},
]

const uniounStatusOption = [
  {label: 'Completed',value: 'dropoff_successful'},
  {label: 'Canceled',value: 'cancel'},
  {label: 'Pending',value: 'pending'},
  {label: 'On Route',value: 'on_route'},
]

const packedTimeOption= [
  {label: 'All',value: ''},
  {label: 'No',value: 'false'},
  {label: 'Yes',value: 'true'},
]

const retailer = [
  {label: 'All',value: ''},
  {label: 'No',value: 'false'},
  {label: 'Yes',value: 'true'},
]

const urgentDeliveryOption = [
  {label: 'All',value: ''},
  {label: 'Normal Orders',value: 'false'},
  {label: 'Urgent Orders',value: 'true'},
]

const returnPickupOption = [
  {label: 'All',value: 'all'},
  {label: 'Delivery',value: 'is_normal'},
  {label: 'Pickup Only',value: 'is_return'},
  {label: 'Exchange',value: 'is_replace'},
]

const sortOption = [
  {label: 'Created At asc',value: 'asc'},
  {label: 'Created At desc',value: 'desc'},
  {label: 'Delay asc',value: 'delay_time_asc'},
  {label: 'Delay desc',value: 'delay_time_desc'},
]

const OrderTaskFilters = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [postDataZoneIdsAll, setPostDataZoneIdsAll] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    postLists()
  }, []);

  const postLists = async() => {
    await props.zoneActions.getZoneListAction();
  }

  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      const zoneDataAll = [];
      props.zoneData.map((item) => {
        zoneData.push({value: item?.storeId, label: item?.zoneName})
        zoneDataAll.push(item?.storeId);
      });
      setPostDataZoneIdsAll(zoneDataAll);
      setPostDataZone([{value: 'all', label: '---SELECT ALL---'}, ...zoneData]);
    }
  }, [props.zoneData]);

  const onChangeHandelZone = async (value) => {
    if(value?.includes("all")){
      form.setFieldsValue({
        ...props.ordersFilter,
        store_id: postDataZoneIdsAll,
      });
    }
  }

  useEffect(() => {
    if (props.pageFilter){
      form.setFieldsValue(props.pageFilter || null);
    }
  }, [props.pageFilter])

  const filterChange = async(value) => {
    const newData = {
      ...props.pageFilter,
      ...value,
      page: 1,
    };
    await props.actionPage.filterAction(newData);
  }

  const resetSearch = async (e) => {
    const newData = {
      page: 1,
      limit: 10,
      date: [moment(), moment()],
      sort: "desc",
    };
    form.resetFields();
    await props.actionPage.filterAction(newData);
  };

  return props?.pageLoading ? <Filterloader /> : (
    <Form form={form} className="fliters_form no-label" disabled={props?.pageLoading} onFinish={filterChange} layout="vertical" initialValues={{ modifier: 'public', }}>
      <Form.Item name={["store_id"]} label='Zone'>
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          onChange={onChangeHandelZone}
          style={{ minWidth: 300}}
          placeholder="Zone"
        />
      </Form.Item>
      <Form.Item name={["non_union_status"]} label={'Status'}>
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={statusOption}
          style={{ minWidth: 160}}
          placeholder="Status"
        />
      </Form.Item>
      <Form.Item name={["union_status"]} label={'Union Status'}>
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={uniounStatusOption}
          style={{ minWidth: 160}}
          placeholder="Union Status"
        />
      </Form.Item>
      <Form.Item name={["date"]} label={'date'}>
        <RangePicker
          allowClear={false}
          format="YYYY-MM-DD"
          placeholder="date"
        />
      </Form.Item>
      <Form.Item name={["customerPhone"]} label={'Customer Phone +92'}>
        <Input
          allowClear
          style={{width: 200,}}
          placeholder="Customer Phone +92"
        />
      </Form.Item>
      <Form.Item name={["rider_filter"]} label={'Rider Name/Phone 03'}>
        <Input
          allowClear
          style={{width: 200,}}
          placeholder="Rider Name/Phone 03"
        />
      </Form.Item>
      <Form.Item name={["rider_id"]} label={'Rider ID'}>
        <Input
          allowClear
          style={{width: 100,}}
          placeholder="Rider ID"
        />
      </Form.Item>
      <Form.Item name={["orderId"]} label={'Order ID'}>
        <Input
          allowClear
          style={{width: 100,}}
          placeholder="Order ID"
        />
      </Form.Item>
      <Form.Item name={["packed_time_exist"]} label={'Packed Time Exist'}>
        <Select
          showSearch
          allowClear
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={packedTimeOption}
          style={{ minWidth: 100}}
          placeholder="Packed Time Exist"
        />
      </Form.Item>
      <Form.Item name={["urgent_delivery"]} label={'Order Criticality'}>
        <Select
          showSearch
          allowClear
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={urgentDeliveryOption}
          style={{ minWidth: 100}}
          placeholder="Order Criticality"
        />
      </Form.Item>
      <Form.Item name={["return_pickup"]} label={'Order Return Pickup'}>
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={returnPickupOption}
          style={{ minWidth: 100}}
          placeholder="Order Return Pickup"
        />
      </Form.Item>
      <Form.Item name={["sort"]} label={'Sort'}>
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={sortOption}
          style={{ minWidth: 100}}
          placeholder="Sort"
        />
      </Form.Item>
      {/* <Form.Item name={["is_retailer"]} label={'Retailer'}>
        <Select
          allowClear
          options={retailer}
          style={{ minWidth: 100}}
          placeholder="Retailer"
        />
      </Form.Item> */}
      <Button htmlType="submit" loading={props?.pageLoading}>Search <SearchOutlined /></Button>
      <Button loading={props?.pageLoading} onClick={()=>resetSearch()}>Reset</Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    pageLoading: state.OrderManagementListingReducer?.initialLoading,
    pageFilter: state.OrderManagementListingReducer?.initialFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(OrderTaskFilters);